// This file re-exports the active Redux modules
// All other Redux/Saga modules have been migrated to RTK Query

/* AUTH - Constants still needed by auth module */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const START_INACTIVITY_TIMER = 'START_INACTIVITY_TIMER';
export const STOP_INACTIVITY_TIMER = 'STOP_INACTIVITY_TIMER';
export const USER_ACTIVITY = 'USER_ACTIVITY';

/* MENU - Constants still needed by menu module */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/* SETTINGS - Constants still needed by settings module */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

import * as menuActions from "./menu/actions";
import * as settingsActions from "./settings/actions";
import * as authActions from "./auth/actions";

// Re-export the modules that are still active
export { menuActions };
export { settingsActions };
export { authActions };
